import axios from 'axios'
import VueSimpleAlert from 'vue-simple-alert'
import store from '../store'
import { getToken } from '@/utils/auth'

// axios 인스턴스 만들기
const service = axios.create({
  baseURL: process.env.BASE_API, // api base_url
  timeout: 30000 // 요청시간 초과
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers.Authorization = getToken()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone interceptor
service.interceptors.response.use(
  response => {
    /**
     * code가 200이 아니면 에러임
     */
    const res = response.data
    if (res.code !== 200) {
      // excel file Blob type 결과
      if (res instanceof Blob) {
        return response
      }
      VueSimpleAlert.alert(res.message)

      // 401: 로그인 실패
      if (res.code === 401) {
        /* MessageBox.confirm('로그아웃 되었습니다.', '로그아웃', {
          confirmButtonText: '재등록',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            window.location.reload() // 버그를 피하기 위하여 vue-router 객체를 다시 인스턴스화
          })
        }) */
      }
      return Promise.reject(res.message)
    }
    return response.data
  },
  error => {
    console.log(`err${error}`) // for debug
    VueSimpleAlert.alert(error.message)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js